const account = {
  state: {
    time: ''
  },

  mutations: {
    SET_TIME: (state, value) => {
      window.localStorage.setItem('cloud_t', value);
    },
    GET_TIME: (state) => {
      state.time = window.localStorage.getItem('cloud_t');
    },
    REMOVE_TIME: (state) => {
      window.localStorage.removeItem('cloud_t');
    }
  },

  actions: {
    
  }
}

export default account



// WEBPACK FOOTER //
// ./src/store/modules/expireTime.js